import React, { useState, createContext, useMemo } from "react";
import PropTypes from "prop-types";
const StateContext = createContext({})
const StateProvider = ({ children }) => {
  const [topbarHeader, setTopbarHeader] = useState("");
  const [exportData, setExportData] = useState(false);
  const state = useMemo(
    () => ({
      topbarHeader,
      setTopbarHeader,
      exportData,
      setExportData,
    }),
    [topbarHeader, exportData]
  );
  return(
    <StateContext.Provider value={state}>
      {children}
    </StateContext.Provider>
  )
}
export { StateContext,StateProvider }

StateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};